const ContactData = [
    {
        id:0,
        link:'http://www.linkedin.com/in/sora-noh',
        icon:'linkedin'
    },
    {
        id:1,
        link:'mailto:nosora0422@gmail.com',
        icon:'email'
    },
    {
        id:2,
        link:'http://github.com/nosora0422',
        icon:'github'
    },

]

export default ContactData;